import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { showHelp, toggleHelp } from '@app/actions/helpActions';

import Button from '@components/buttons/Button';
import './HelpTip.scss';

const HelpTip = ({ tipLocKey = 'qau-empty-text', showHelp, toggleHelp, helpSection, helpTopic, onClick, ...props }) => {
  const onHelpTipClick = useCallback(() => {
    helpSection && helpTopic ? showHelp(helpSection, helpTopic) : toggleHelp();
    onClick && onClick();
  }, [helpSection, helpTopic, showHelp, onClick]);

  return (
    <Button className="help-tip" onClick={onHelpTipClick} {...props}>
      <span className="help-tip-icon" />
      <LocalizedText id={tipLocKey} tagName="span" />
    </Button>
  );
};

HelpTip.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  showHelp: PropTypes.func.isRequired,
  toggleHelp: PropTypes.func.isRequired,
  tipLocKey: PropTypes.string.isRequired,
  helpTopic: PropTypes.string,
  helpSection: PropTypes.string,
};

export default connect(null, { showHelp, toggleHelp })(HelpTip);
